import Component from 'vue-class-component';
import { Prop, Vue } from 'vue-property-decorator';
import EdCustomizeComponentsCourse from '@/course-templates/components/ed-customize-components-course/ed-customize-components-course.component.vue';

@Component({
  name: 'ed-settings-menu',
  components: {EdCustomizeComponentsCourse}
})
export default class EdSettingsMenu extends Vue {

  @Prop() readonly params: any;

  /* Computed */
  get settingsMenu() {
    return this.getMenu();
  }

  /* Methods */
  showCustomizeComponent() {
    this.$EdModal.createBootstrapModal(EdCustomizeComponentsCourse, {
      courseId: this.params.courseId,
      classId: this.params.classId,
      components: this.params.components
    });
  }

  getMenu() {
    const menu: any = [{
      id: 1,
      text: this.$i18n.t('courses.eduacComponents.customizeComponents'),
      action: this.showCustomizeComponent.bind(this),
      params: this.params
    }];
    
    return menu;
  }

  mounted() {
    this.$edEventBus.$on('openComponentsModal', this.showCustomizeComponent)
  }

  destroyed() {
    this.$edEventBus.$off('openComponentsModal')
  }

}